"use client"

import { ThemeSwitcher } from "./theme-switcher"
import LanguageSwitcher from "./LanguageSwitcher"
import { FontSwitcher } from "./font-switcher"
import { Globe, Palette, Type } from "lucide-react"

export function TopHeader() {
  return (
    <div className="bg-gradient-to-r from-primary/90 via-primary/80 to-primary/90 backdrop-blur-lg border-b border-white/20 relative z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2">
        <div className="flex items-center justify-end">
          {/* Left side - Brand info */}
          
          {/* Right side - Controls */}
          <div className="flex items-center gap-1.5 sm:gap-2">

            
            {/* Switchers */}
            <div className="flex items-center gap-1.5 sm:gap-2">
              <LanguageSwitcher />
              <FontSwitcher />
              <ThemeSwitcher />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}